
import React from 'react';
import { Mail } from 'lucide-react';
import EmailConfigForm from '@/components/EmailConfigForm';

interface EmailSettingsTabProps {
  initialConfig: any | null;
  onSaved: () => void;
}

const EmailSettingsTab: React.FC<EmailSettingsTabProps> = ({ 
  initialConfig, 
  onSaved 
}) => {
  return (
    <div className="space-y-4">
      <div className="flex items-center gap-2 mb-4">
        <Mail className="h-5 w-5 text-primary" />
        <h2 className="text-xl font-semibold">Email Configuration</h2>
      </div>
      <EmailConfigForm 
        initialConfig={initialConfig} 
        onSaved={onSaved} 
      />
    </div>
  );
};

export default EmailSettingsTab;
